<p-card #glMailCard styleClass="h-full p-4">
    <ng-template pTemplate="header">
        <h2>Group Leader Mail</h2>
    </ng-template>
    
    <div 
        class="gl-mail-scroll-container mini-scrollbar pr-2"
        [style.height]="getScrollPanelHeight()">
        <div class="flex flex-col gap-3 w-full">
            <div *ngFor="let message of messages()" class="mail-item w-full">
               <app-gl-mail-item [message]="message"></app-gl-mail-item>
            </div>
            <div *ngIf="messages().length === 0" class="text-center p-6 text-gray-500">
                <div class="text-lg font-medium">No messages to display</div>
                <div class="text-sm mt-1">All group leader messages have been addressed</div>
            </div>
        </div>
    </div>
</p-card> 